import React from 'react'
import { Page, Document, StyleSheet, Image} from '@react-pdf/renderer';
import InvoiceItemsTable from './pdf/InvoiceItemsTable';
import InvoiceTitle from './pdf/InvoiceTitle';
import Sign from './pdf/sign';
import 'moment/locale/es';
import InvoiceItemsTableList from './pdf/InvoiceItemsTableList';
import moment from 'moment';


function getRealAge(dateString) {
    
    if(!dateString || dateString == null) {
        return "";
    }
var starts = moment(dateString);
var ends   = moment();
var duration = moment.duration(ends.diff(starts));

return duration.years() + " años "+ duration.months()  +" meses";
}
export default function RemisionesPDF(props) {
    const styles = StyleSheet.create({
        page: {
            fontFamily: 'Helvetica',
            fontSize: 11,
            paddingTop: 30,
            paddingLeft:60,
            paddingRight:60,
            lineHeight: 1.5,
            flexDirection: 'column',
        }, 
        logo: {
            width: '100%',
            height: 'auto',
            //marginLeft: 'auto',
            //marginRight: 'auto'
        }
      }); 
    
      const personalInfo = [
        {
            id: 1,
            key: "NOMBRE:",
            value: props.affiliateInfo.patient.firstName + " "  +
                `${props.affiliateInfo.patient.secondName || ''}` + " "  +
                 props.affiliateInfo.patient.lastName + " "  +
                `${props.affiliateInfo.patient.secondLastName || ''}` 
         },
         {
            id: 2,
            key: "TIPO IDENTIFICACIÓN:",
            value: props.affiliateInfo.patient.typeId
        },
         {
             id: 3,
             key: "IDENTIFICACIÓN:",
             value: props.affiliateInfo.patient.id
         },
         {
             id: 4,
             key: "EPS:",
             value: props.affiliateInfo.patient.eps
         },
         {
            id: 5,
            key: "REGIMEN:",
            value: props.affiliateInfo.patient.regimen
        },
         {
             id: 6,
             key: "EDAD:",
             value: getRealAge(props.affiliateInfo.patient.birthday)
         },
        
         {
             id: 6,
             key: "TELEFONO:",
             value: props.affiliateInfo.patient.cellphone
         },
     
         {
             id: 7,
             key: "DIRECCION:",
             value: props.affiliateInfo.patient.address
         },
     
         {
             id: 8,
             key: "MUNICIPIO:",
             value: props.affiliateInfo.patient.residenceCode
         }
       ]

       let originInfo = props.affiliateInfo.evolutions;
     
       if (props.printAdditionalInfo) {
          originInfo =  props.affiliateInfo.additionalsInfo;
       }
       const remisiones = []
       originInfo[props.indexEvolution].referrals.map( (item, index) => 
       remisiones.push([
       {
          id: index,
          key: "REMITIDO A:",
          value: item.description
       },
       {
          id: index + 20,
          key: "OBSERVACIONES:",
          value: item.observations
       }
    ]
      )
      )

      const diagnoses = [['#',"CIE10", "DESCRIPCIÓN",  "CLASE DIAGNOSTICO"] ]
      
      originInfo[props.indexEvolution].diagnoses
            .filter(diagnose => diagnose.classDiagnosis == "Diagnostico Principal").map( (item, index) => {
          diagnoses.push([index + 1, item.id, item.description, item.classDiagnosis ])
      }
      )
  

   const titleInfo = "REMISION(ES): ";
        return (
            
            <Document title={"Historia Clinica"}>

            {remisiones.map(element => 
            <Page size="A4" style={styles.page}> 
                 <Image style={styles.logo} src="https://my-market-mompos-online.s3.amazonaws.com/medisas-resource/logo_pdf_2.png"></Image>
                <InvoiceTitle title={titleInfo} dateAttend={originInfo[props.indexEvolution].assessmentDate}/>
                <InvoiceItemsTable items={personalInfo} title={"DATOS DE IDENTIFICACION DEL USUARIO"}  separator={2} />
                <InvoiceItemsTableList items={diagnoses} title={"IMPRESIÓN DIAGNÓSTICA"}  separator={2} />
                <InvoiceItemsTable items={element} title={"REMISIÓN(ES)"}  separator={1} />
                <Sign medical={props.affiliateInfo.medicalTeam} patient={props.affiliateInfo.patient} />

            </Page>
        )}
          </Document>
        )
    };